import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Activity, Shield, User } from 'lucide-react';
import { Pill } from './primitives.jsx';
import NetworkMenu from './NetworkMenu.jsx';

export default function AppShell({ children }) {
  const loc = useLocation();
  const onLanding = loc.pathname === '/';

  if (onLanding) return <>{children}</>;

  const navItems = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/inventory', label: 'VDOT inventory' },
    { to: '/report',    label: 'Sample report' },
    { to: '/pricing',   label: 'Pricing' },
  ];

  return (
    <div className="min-h-screen bg-stone-100 text-stone-900 font-sans">
      <header className="bg-white border-b border-stone-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-[#032953] flex items-center justify-center p-1 rounded-sm">
                <img src="/atlas-symbol.png" alt="Atlas GEO Technologies" className="w-full h-full object-contain" />
              </div>
              <div className="flex flex-col">
                <span className="text-[#0a0a0a] font-bold text-base leading-none tracking-tight">ATLASPATH</span>
                <span className="text-[11px] text-[#DBC078] font-semibold uppercase tracking-[0.18em] mt-0.5">by Atlas GEO Technologies</span>
              </div>
            </Link>
            <nav className="flex items-center gap-1">
              {navItems.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  className={({ isActive }) =>
                    `px-3 py-1.5 text-xs uppercase tracking-wider transition-colors ${
                      isActive ? 'bg-[#0a0a0a] text-white' : 'text-stone-600 hover:text-[#0a0a0a] hover:bg-stone-100'
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3 text-xs">
            <div className="hidden lg:flex items-center gap-2 text-stone-500">
              <Activity size={12} className="text-emerald-500" />
              <span>Live data</span>
              <span className="text-stone-400">·</span>
              <span>VDOT: May 2026</span>
            </div>
            <NetworkMenu variant="dark" />
            <div className="hidden md:flex items-center gap-2 px-3 py-1.5 border border-stone-200">
              <User size={12} className="text-stone-500" />
              <span className="text-stone-700">Demo user</span>
              <span className="text-[10px] uppercase tracking-wider text-[#1F7A8C] bg-[#1F7A8C]/10 px-1.5 py-0.5">Guest</span>
            </div>
          </div>
        </div>
        <div className="gold-stripe" />
      </header>

      <main className="max-w-7xl mx-auto px-6 py-6">{children}</main>

      <footer className="border-t border-stone-200 mt-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-stone-500 flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Shield size={12} />
            <span>AtlasGeo Technologies LLC</span>
            <span>·</span>
            <Pill className="bg-stone-100 text-stone-600 border-stone-200">SDVOSB</Pill>
            <Pill className="bg-stone-100 text-stone-600 border-stone-200">MBE · Virginia</Pill>
          </div>
          <div className="flex items-center gap-3">
            <a href="mailto:info@atlasgeo.ai" className="hover:text-[#0a0a0a]">info@atlasgeo.ai</a>
            <span>·</span>
            <span>Demo data: VDOT public inventory (May 2026)</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
